// 多选类型的HeaderCell
import { HeaderFieldCellMixins } from './mixins.js';

const selection_header_cell = Vue.extend({
  mixins: [HeaderFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container list">
        <div class="list-item"
             v-for='option in mergedOptions'
             :key='option.id'
             @click='toggleOption(option)'>
          <div class="content">{{ option.value }}</div>
          <div class="tip" v-if='option._selected'>
            <i class="slp-check"></i>
          </div>
        </div>
      </div>
    </div>
  `,

  data: function() {
    return {
      filterOptions: [],
      mergedOptions: []
    };
  },

  created: function() {
    this.mergedOptions = this._initOptions();
  },

  methods: {
    getFilter: function() {
      var selected_options;

      selected_options = _.filter(this.mergedOptions, (option) => option._selected);
      if (selected_options.length) {
        return selected_options;
      } else {
        return null;
      }
    },

    resetFilter: function() {
      this.filterOptions = this.filter?.value || [];
      this.mergedOptions = this._initOptions();
    },

    toggleOption: function(option) {
      option._selected = !option._selected;
      this.$emit('filterChanged', false);
    }
  }
});

const optionable_cell = Vue.extend({
  extends: selection_header_cell,

  methods: {
    _initOptions: function() {
      var options;

      options = _.map(this.field.options, (option) => {
        option = _.clone(option);
        option._selected = _.some(this.filterOptions, (_option) => option.id === _option.id);
        return option;
      });
      if (this.field.other_option) {
        options.push({
          value: '其他',
          id: 0,
          _selected: _.some(this.filterOptions, (option) => option.id === 0)
        });
      }
      return options;
    }
  }
});

const YAW__AssignmentStatusHeaderCell = Vue.extend({
  extends: selection_header_cell,

  methods: {
    _initOptions: function() {
      var all_statuses;

      all_statuses = ['processing', 'approved', 'refused', 'transferred', 'skipped', 'aborted', 'suspended'];
      return _.map(all_statuses, (status) => ({
        value: Skylark.Helpers.translate(`assignment.status.${status}`),
        id: status,
        _selected: _.some(this.filterOptions, (option) => option.id === status)
      }));
    }
  }
});

export { YAW__AssignmentStatusHeaderCell };

export {
  optionable_cell as RadioButtonHeaderCell,
  optionable_cell as CheckBoxHeaderCell
};
